import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'
import config from '../../../../config'

import { AuthGDPR } from '../common/AuthGDPR'
import { AuthResponsable } from '../common/AuthResponsable'
import { AuthEdat17 } from '../common/AuthEdat17'

import { AuthCompromis, AuthCompromisMenors16 } from './AuthCompromis'
import { AuthMobils } from './AuthMobils'
import { AuthDretsImatge } from './AuthDretsImatge'
import { AuthRecursosDigitals } from './AuthRecursosDigitals'
import { AuthSortides } from './AuthSortides'
import { AuthSortidaAbsencia } from './AuthSortidaAbsencia'
import { AuthMedica } from './AuthMedica'


export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  
  const [authCompromis, setAuthCompromis ] = useState("0");
  const [authGDPR, setAuthGDPR ] = useState("0");
  const [authResponsable, setAuthResponsable ] = useState("0");
  const [authSortides, setAuthSortides ] = useState();
  const [authSortidaAbsencia, setAuthSortidaAbsencia ] = useState();
  const [authMedica, setAuthMedica ] = useState("0");
  const [authDretsImatge , setAuthDretsImatge ] = useState("0");
  const [authMobils, setAuthMobils] = useState("0");
  const [authRecursosDigitals, setAuthRecursosDigitals] = useState("0");

  const major18 = props.dadesPersonals.edat >= 18 || false
  const major16 = props.dadesPersonals.edat >= 16 || false

  //const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {
    let d = {
     "validat": noError,

    /* DADES AUTORITZACIONS */
    "authCompromis": authCompromis,
    "authGDPR": authGDPR,
    "authResponsable": authResponsable,
    "authSortides": authSortides,
    "authSortidaAbsencia": authSortidaAbsencia,
    "authMedica": authMedica,
    "authDretsImatge": authDretsImatge,
    "authMobils": authMobils,
    "authRecursosDigitals": authRecursosDigitals,
    }
  
      //console.log("DADES_AUTORITZACIONS",d)
      //setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }

  const validaCheck= (auth) => {
    return auth === "1" ? null : "Aquest camp és obligatori"
  }

  const validaYN= (auth) => {
    return auth ? null : "Heu d'indicar una resposta"
  }


 const handleChangeAuthDretsImatge = (t) => {

      setAuthDretsImatge( t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeRecursosDigitals = (t) => {

      setAuthRecursosDigitals( t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }


 const handleChangeCompromis = (t) => {

      setAuthCompromis(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0") 

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 const handleChangeResponsable = (t) => {

      setAuthResponsable(t === "0" ? "1" : "0") 

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 const handleChangeMobils = (t) => {

      setAuthMobils(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeSortides = (t) => {

      setAuthSortides(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeSortidaAbsencia = (t) => {

      setAuthSortidaAbsencia(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeMedica= (t) => {

      setAuthMedica(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }


/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  error.authCompromis = validaCheck(authCompromis)

  error.authMobils = validaCheck(authMobils)

  error.authDretsImatge = validaCheck(authDretsImatge)

  error.authRecursosDigitals = validaCheck(authRecursosDigitals)

  error.authSortides = validaYN(authSortides)

  error.authSortidaAbsencia = validaYN(authSortidaAbsencia)

  if (!major18 ){
  error.authMedica = validaCheck(authMedica)
  }

  error.authGDPR = validaCheck(authGDPR)

  error.authResponsable = validaCheck(authResponsable)

  console.log("E",error)
  setErrors(error)

  let noError = true;
  //DEVELOP 
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).forEach( (k) => { if(error[k] !== null) noError = false } )
  }

  //console.log('ERROR',error);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">


                                {major16 ? (
                                  <AuthCompromis auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} />
                                ) : (
                                  <AuthCompromisMenors16 auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} />
                                )
                                } <br />

                                <AuthMobils auth={authMobils} handleChange={handleChangeMobils} error={errors.authMobils} /> <br />

                                <AuthDretsImatge auth={authDretsImatge} handleChange={handleChangeAuthDretsImatge} error={errors.authDretsImatge} /> <br />

                                <AuthRecursosDigitals auth={authRecursosDigitals} handleChange={handleChangeRecursosDigitals} error={errors.authRecursosDigitals} /> <br />

                                <AuthSortides auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} /> <br />

                                <AuthSortidaAbsencia auth={authSortidaAbsencia} handleChange={handleChangeSortidaAbsencia} error={errors.authSortidaAbsencia} /> <br />

                                {!major18 && (<>
                                  <AuthMedica auth={authMedica} handleChange={handleChangeMedica} error={errors.authMedica} /> <br />
                                </>)}

                                <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} error={errors.authGDPR} />

                                <AuthResponsable auth={authResponsable} handleChange={handleChangeResponsable} error={errors.authResponsable} />

                                <AuthEdat17 edat={props.dadesPersonals.edat} />

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>












                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}